import { render } from "./SearchVote.vue?vue&type=template&id=a05d53d4&scoped=true"
import script from "./SearchVote.vue?vue&type=script&lang=js"
export * from "./SearchVote.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=a05d53d4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a05d53d4"]])

export default __exports__